import { render, staticRenderFns } from "./InAgeBody.vue?vue&type=template&id=0866dbeb&"
import script from "./InAgeBody.vue?vue&type=script&lang=js&"
export * from "./InAgeBody.vue?vue&type=script&lang=js&"
import style0 from "./InAgeBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports